import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-switch-lang';
import Breadcrumb from '../components/Breadcrumb';
import PageCard from '../containers/PageCard';
import ChatMain from './Chat/ChatMain';
import appState from '../storages/mobx/appState';
import NotificationStatus from '../components/NotificationStatus';

class Channels extends Component {
  componentDidMount() {
    appState.toggleSidebar();
  }

  render() {
    const { t } = this.props;
    return (
      <>
        {/* <Breadcrumb title={t('Channels')} parent={t('Home')} /> */}
        <ChatMain />
      </>
    );
  }
}

Channels.propTypes = {};

export default translate(Channels);
